import { render } from "./qrcode.vue?vue&type=template&id=19835180&scoped=true&ts=true"
import script from "./qrcode.vue?vue&type=script&lang=ts"
export * from "./qrcode.vue?vue&type=script&lang=ts"

import "./qrcode.vue?vue&type=style&index=0&id=19835180&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19835180"]])

export default __exports__